// export const BaseGatewayImage = 'https://localhost:5001';
// export const BaseGateway = 'https://localhost:5001/api/v1';
// export const BaseGatewayDomain = 'https://localhost:3000';

// export const BaseGatewayAuthApi = 'https://localhost:5003/api/v1';
// export const BaseGatewayAuth = 'https://localhost:5003';
// export const BaseGatewayAuthImage = 'https://localhost:5003';
// export const BaseGatewayCommon = 'https://localhost:4999/api/v1';

// export const BaseGatewayImage = 'https://api.testapp.cntt108.vn';
// export const BaseGateway = 'https://api.testapp.cntt108.vn/api/v1';
// export const BaseGatewayDomain = 'https://testapp.cntt108.vn';

export const BaseGatewayImage = 'https://api.huanluyendaotao.cntt108.vn';
export const BaseGateway = 'https://api.huanluyendaotao.cntt108.vn/api/v1';
export const BaseGatewayDomain = 'https://huanluyendaotao.cntt108.vn';

export const BaseGatewayAuthApi = 'https://api.authservice.cntt108.vn/api/v1';
export const BaseGatewayAuth = 'https://api.authservice.cntt108.vn';
export const BaseGatewayAuthImage = 'https://api.authservice.cntt108.vn';
export const BaseGatewayCommon = 'https://api.corehub.cntt108.vn/api/v1';

// export const BaseGatewayImage = 'http://localhost:5000';
// const BaseGateway = 'http://localhost:5000/api/v1';


// export const BaseGatewayImageAuth = 'http://localhost:5002';
// const BaseGatewayAuth = 'http://localhost:5002';

export const BaseGatewayNest = 'http://localhost:8080';

const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const BaseGatewayClient = 'http://interbgc.com.vn'

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info';
// api chung lấy nguộn 
export const AUTH_API = {
    LOGIN_API: `${BaseGatewayAuth}/connect/token`,
    REFRESHTOKEN_API: `${BaseGatewayAuth}/connect/token`,
    CHANGE_PASSWORD_API: `${BaseGatewayAuthApi}/Account/ChangePassword`,
    FORGOT_PASSWORD: `${BaseGatewayAuth}/Auth/ForgotPassword`,
    RESET_PASSWORD: `${BaseGatewayAuth}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
    GET_PAGING_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetAllPaging`,
    GET_PAGING_ACCOUNT_NOT_MENU: `${BaseGatewayAuthApi}/Account/GetAllPagingNotMenu`,
    ADD_ACCOUNT: `${BaseGatewayAuthApi}/Account/Create`,
    ADD_MANY_ACCOUNT: `${BaseGatewayAuthApi}/Account/CreateMany`,
    ADD_ROLE_TO_ACCOUNT: `${BaseGatewayAuthApi}/Account/AddRoleToAccount`,
    RESET_ROLE_TO_ACCOUNT: `${BaseGatewayAuthApi}/Account/ResetRoleToAccount`,
    APPROVE_INTERNAL_SOFTWARE_ACCESS: `${BaseGatewayAuthApi}/Account/ApproveInternalSoftwareAccess`,
    EDIT_ACCOUNT: `${BaseGatewayAuthApi}/Account/Update`,
    DELETE_ACCOUNT: `${BaseGatewayAuthApi}/Account/DeleteItem`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetItem`,
    COUNT_ALL_ACCOUNT_API: `${BaseGatewayAuthApi}/Account/CountAllAccount`,
    GET_ACCOUNT_INFO: `${BaseGateway}/AccountInfo/GetAccountInfo`,
    GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG: `${BaseGatewayCommon}/AccountInfo/SelectAccountInfoByAccountId`,
    GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG: `${BaseGatewayAuthApi}/AccountAuthInfo/GetItem`,
    GET_PAGING_ACCOUNT_FROM_APP_DUNGCHUNG: `${BaseGatewayCommon}/AccountInfo/GetAllByPaging`
};

export const ACCOUNT_AUTHINFO_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/AccountAuthInfo/GetAllByPaging`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/AccountAuthInfo/GetItem`,
    GET_BY_USERNAME: `${BaseGatewayAuthApi}/AccountAuthInfo/GetAccountAuthInfoByUsername`,
};

export const OPENIDDICTAPPLICATION_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/OpeniddictApplication/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/DeleteItem`
};

// export const FILE_MANAGER_API = {
//     UPLOAD: `${BaseGatewayAuthApi}/FileManager/Upload`,
//     GET_PAGING: `${BaseGatewayAuthApi}/FileManager/GetAllPaging`,
//     GET_DIR_PATH: `${BaseGatewayAuthApi}/FileManager/GetDirectoryPath`,
//     DELETE: `${BaseGatewayAuthApi}/FileManager`
// };

export const FILE_MANAGER_API = {
    UPLOAD: `${BaseGateway}/FileManager/Upload`,
    UPLOAD_INPUT_FILE: `/api/v1/FileManager/Upload`,
    GET_PAGING: `${BaseGateway}/FileManager/GetAllPaging`,
    GET_DIR_PATH: `${BaseGateway}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGateway}/FileManager/Delete`,
    DELETE_FILE_PATH: `${BaseGateway}/FileManager/DeleteFilePath`,
};

export const EMAILCONFIG_API = {
    GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
    GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
    ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
    UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
    DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const LOGIN_HISTORY_API = {
    GET_PAGING_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetAllPaging`,
    STATISTIC_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetStatisticsLoginByAccount`,
    STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGatewayAuth}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
    GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
    DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
    COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`,
};


// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPaging`,
//     GET_PAGING_NOT_MENU: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPagingNotMenu`,
//     GET_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGatewayAuthApi}/ApiRoleMapping/BulkAssignRoles`
// };

// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGatewayCommon}/ApiRoleMapping/GetAllByPaging`,
//     GET_PAGING_NOT_MENU: `${BaseGateway}/ApiRoleMapping/GetAllByPagingNotMenu`,
//     GET_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGatewayCommon}/ApiRoleMapping/BulkAssignRoles`
// };

export const APIROLEMAPPING_API = {
    GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/ApiRoleMapping/GetAllByPagingNotMenu`,
    GET_PAGING_AUTH_NOT_MENU: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
    ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
    UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
    BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
};

export const ROLE_API = {
    GET_ALL: `${BaseGatewayAuthApi}/Role/GetAll`,
    GET_PAGING: `${BaseGatewayAuthApi}/Role/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/Role/GetItem`,
    GET_ITEM_ROLE: `${BaseGatewayAuthApi}/Role/GetItemRole`,
    ADD_ITEM: `${BaseGatewayAuthApi}/Role/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/Role/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/Role/DeleteItem`,
    UPDATE_TREE: `${BaseGatewayAuthApi}/Role/UpdateTree`
};

export const MENU_API = {
    GET_PAGING: `${BaseGateway}/MenuItem/GetAllByPaging`,
    GET_MENU: `${BaseGateway}/MenuItem/GetMenu`,
    GET_ITEM: `${BaseGateway}/MenuItem/GetItem`,
    ADD_ITEM: `${BaseGateway}/MenuItem/Create`,
    UPDATE_ITEM: `${BaseGateway}/MenuItem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MenuItem/DeleteItem`,
    UPDATE_TREE: `${BaseGateway}/MenuItem/UpdateTree`
};

export const KYSO_API = {
    KYSO: `${BaseGateway}/KySo/AuthorizeKySo`,
    KYSO_ONE_FILE_ONE_SIGNATURE: `${BaseGateway}/KySo/AuthorizeKySoOneFileOneSignature`,
};

export const SIGNEDHUMAN_API = {
    GET_PAGING: `${BaseGateway}/SignedHuman/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/SignedHuman/GetItem`,
    ADD_ITEM: `${BaseGateway}/SignedHuman/Create`,
    UPDATE_ITEM: `${BaseGateway}/SignedHuman/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/SignedHuman/DeleteItem`,
    EXPORT_USERS_PDF: `${BaseGateway}/SignedHuman/ExportPdfListUser`,
    EXPORT_PDF: `${BaseGateway}/SignedHuman/ExportPdfToSign`,
    // EXPORT_USERS_PDF: `${BaseGateway}/SignedHuman/ExportPdf`,
    // EXPORT_USERS_PDF: `${BaseGateway}/SignedHuman/FillPdf`,
    // EXPORT_USERS_PDF: `${BaseGatewayNest}/export-pdf`,
};

export const CHUDE_API = {
    GET_PAGING: `${BaseGateway}/ChuDe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuDe/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuDe/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuDe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuDe/DeleteItem`,
};

export const HOADONTHANHTOAN_API = {
    GET_PAGING: `${BaseGateway}/HoaDonThanhToan/GetAllByPaging`,
    GET_DOANH_THU: `${BaseGateway}/HoaDonThanhToan/GetDoanhThu`,
    GET_ITEM: `${BaseGateway}/HoaDonThanhToan/GetItem`,
    GET_ITEM_BY_ERPID_AND_STATUS: `${BaseGateway}/HoaDonThanhToan/GetItemWithErpIdAndStatus`,
    ADD_ITEM: `${BaseGateway}/HoaDonThanhToan/Create`,
    REQUEST_REPLACE: `${BaseGateway}/HoaDonThanhToan/YeuCauThayTheHoaDon`,
    REQUEST_ADJUST: `${BaseGateway}/HoaDonThanhToan/YeuCauDieuChinhGiam`,
    UPDATE_STATUS_PHAT_HANH: `${BaseGateway}/HoaDonThanhToan/UpdateStatusPhatHanh`,
    UPDATE_ITEM: `${BaseGateway}/HoaDonThanhToan/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HoaDonThanhToan/DeleteItem`,
};

export const HOADON_API = {
    PHAT_HANH: `${BaseGateway}/HoaDon/PhatHanh`,
    THAY_THE: `${BaseGateway}/HoaDon/ThayThe`,
    DIEU_CHINH: `${BaseGateway}/HoaDon/DieuChinhGiam`,
    XEM_HOA_DON: `${BaseGateway}/HoaDon/XemHoaDon`,
    KIEM_TRA_TRANG_THAI: `${BaseGateway}/HoaDon/KiemTraTrangThai`,
};

export const DANHMUCPHANMEM_API = {
    GET_PAGING: `${BaseGateway}/DanhMucPhanMem/GetAllByPaging`,
    GET_PAGING_SHOW: `${BaseGateway}/DanhMucPhanMem/GetAllByPagingShow`,
    GET_ITEM: `${BaseGateway}/DanhMucPhanMem/GetItem`,
    ADD_ITEM: `${BaseGateway}/DanhMucPhanMem/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhMucPhanMem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhMucPhanMem/DeleteItem`,
};

export const CHUONGTRINHHOC_API = {
    GET_PAGING: `${BaseGateway}/ChuongTrinhHoc/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuongTrinhHoc/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuongTrinhHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuongTrinhHoc/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuongTrinhHoc/DeleteItem`,
};

export const NGANH_API = {
    GET_PAGING: `${BaseGateway}/Nganh/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/Nganh/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/Nganh/GetItem`,
    ADD_ITEM: `${BaseGateway}/Nganh/Create`,
    UPDATE_ITEM: `${BaseGateway}/Nganh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/Nganh/DeleteItem`,
};

export const NHOMTIEUCHI_API = {
    GET_PAGING: `${BaseGateway}/NhomTieuChi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/NhomTieuChi/GetItem`,
    ADD_ITEM: `${BaseGateway}/NhomTieuChi/Create`,
    UPDATE_ITEM: `${BaseGateway}/NhomTieuChi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/NhomTieuChi/DeleteItem`,
};

export const TIEUCHI_API = {
    GET_PAGING: `${BaseGateway}/TieuChi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/TieuChi/GetItem`,
    ADD_ITEM: `${BaseGateway}/TieuChi/Create`,
    UPDATE_ITEM: `${BaseGateway}/TieuChi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/TieuChi/DeleteItem`,
};

export const MUCDANHGIA_API = {
    GET_PAGING: `${BaseGateway}/MucDanhGia/GetAllByPaging`,
    CREATE_ITEM: `${BaseGateway}/MucDanhGia/Create`,
    UPDATE_ITEM: `${BaseGateway}/MucDanhGia/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MucDanhGia/DeleteItem`,
    GET_ITEM: `${BaseGateway}/MucDanhGia/GetItem`
};

export const CHITIETKETQUANCS_API = {
    GET_PAGING: `${BaseGateway}/ChiTietKetQuaNCS/GetAllByPaging`,
    CREATE_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/DeleteItem`,
    GET_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/GetItem`
};

export const CHUYENNGANH_API = {
    GET_PAGING: `${BaseGateway}/ChuyenNganh/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/ChuyenNganh/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/ChuyenNganh/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuyenNganh/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuyenNganh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuyenNganh/DeleteItem`,
};

export const DANHMUCVANBANGCHUNGCHI_API = {
    GET_PAGING: `${BaseGateway}/DanhMucVanBangChungChi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/GetItem`,
    ADD_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/DeleteItem`,
};

export const DOTTUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/DotTuyenSinh/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/DotTuyenSinh/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/DotTuyenSinh/GetItem`,
    ADD_ITEM: `${BaseGateway}/DotTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/DotTuyenSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DotTuyenSinh/DeleteItem`,
    GET_LIST_NAM: `${BaseGateway}/DotTuyenSinh/GetListNamTuyenSinh`,
};

export const THANHTOANLEPHI_API = {
    GET_PAGING: `${BaseGateway}/ThanhToanLePhi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ThanhToanLePhi/GetItem`,
    ADD_ITEM: `${BaseGateway}/ThanhToanLePhi/Create`,
    UPDATE_ITEM: `${BaseGateway}/ThanhToanLePhi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ThanhToanLePhi/DeleteItem`,
};

export const LOPDAOTAOLIENTUC_API = {
    GET_PAGING: `${BaseGateway}/LopDaoTaoLienTuc/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/LopDaoTaoLienTuc/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/LopDaoTaoLienTuc/GetItem`,
    ADD_ITEM: `${BaseGateway}/LopDaoTaoLienTuc/Create`,
    UPDATE_ITEM: `${BaseGateway}/LopDaoTaoLienTuc/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/LopDaoTaoLienTuc/DeleteItem`,
    GET_LIST_NAM_KHAI_GIANG: `${BaseGateway}/LopDaoTaoLienTuc/GetListNamKhaiGiang`,
};

export const LOPDAOTAOTHUCHANH_API = {
    GET_PAGING: `${BaseGateway}/LopDaoTaoThucHanh/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/LopDaoTaoThucHanh/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/LopDaoTaoThucHanh/GetItem`,
    ADD_ITEM: `${BaseGateway}/LopDaoTaoThucHanh/Create`,
    UPDATE_ITEM: `${BaseGateway}/LopDaoTaoThucHanh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/LopDaoTaoThucHanh/DeleteItem`,
    GET_LIST_NAM_KHAI_GIANG: `${BaseGateway}/LopDaoTaoThucHanh/GetListNamKhaiGiang`,
};

export const HOSOLUUTRU_API = {
    GET_PAGING: `${BaseGateway}/HoSoLuuTru/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HoSoLuuTru/GetItem`,
    CREATE_ITEM: `${BaseGateway}/HoSoLuuTru/Create`,
    UPDATE_ITEM: `${BaseGateway}/HoSoLuuTru/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HoSoLuuTru/DeleteItem`,
};

export const DANGKY_DOTTUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/DangKyDotTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DangKyDotTuyenSinh/GetItem`,
};

export const HOSO_TUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/HoSoTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HoSoTuyenSinh/GetItem`,
    ADD_ITEM: `${BaseGateway}/HoSoTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/HoSoTuyenSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HoSoTuyenSinh/DeleteItem`,
};

export const DUYET_HOSO_TUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/DuyetHoSoTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetHoSoTuyenSinh/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetHoSoTuyenSinh/DuyetHoSo`,
};

export const LYLICHKHOAHOC_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/LyLichKhoaHoc/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/LyLichKhoaHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/LyLichKhoaHoc/Update`,
};

export const MINHCHUNGKHOAHOC_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/MinhChungKhoaHoc/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/MinhChungKhoaHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/MinhChungKhoaHoc/Update`,
};

export const DECUONGNGHIENCUU_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/DeCuongNghienCuu/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/DeCuongNghienCuu/Create`,
    UPDATE_ITEM: `${BaseGateway}/DeCuongNghienCuu/Update`,
};

export const VANBANGTUYENSINH_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/VanBangTuyenSinh/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/VanBangTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBangTuyenSinh/Update`,
    DELETE_ITEM: `${BaseGateway}/VanBangTuyenSinh/Delete`,
};

export const VANBANGDAIHOC_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/VanBangDaiHoc/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/VanBangDaiHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBangDaiHoc/Update`,
    DELETE_ITEM: `${BaseGateway}/VanBangDaiHoc/Delete`,
};

export const VANBANGCHUNGCHINGOAINGU_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/VanBangChungChiNgoaiNgu/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/VanBangChungChiNgoaiNgu/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBangChungChiNgoaiNgu/Update`,
    DELETE_ITEM: `${BaseGateway}/VanBangChungChiNgoaiNgu/Delete`,
};


export const DANGKYDUTUYEN_API = {
    GET_PAGING: `${BaseGateway}/DangKyDuTuyen/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DangKyDuTuyen/GetItem`,
    ADD_ITEM: `${BaseGateway}/DangKyDuTuyen/Create`,
    UPDATE_ITEM: `${BaseGateway}/DangKyDuTuyen/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DangKyDuTuyen/DeleteItem`,
};

export const CME_ADMIN_API = {
    GET_CATEGORIES: `${BaseGateway}/CMEAdmin/ConfigCategories`,
    GET_CATEGORY_ITEM: `${BaseGateway}/CMEAdmin/ConfigCategoryById`, // sẽ + /{id}
    ADD_UPDATE_CATEGORY: `${BaseGateway}/CMEAdmin/ConfigCategory`,
    DELETE_CATEGORY: `${BaseGateway}/CMEAdmin/DeleteCategory`, // sẽ + /{id}
    GET_RULE_ITEM: `${BaseGateway}/CMEAdmin/ConfigRuleById`, // sẽ + /{id}
    ADD_UPDATE_RULE: `${BaseGateway}/CMEAdmin/ConfigRule`,
    DELETE_RULE: `${BaseGateway}/CMEAdmin/DeleteRule`, // sẽ + /{id}
    GET_ALL_HO_SO: `${BaseGateway}/CMEAdmin/HoSoPaging`,
    DUYET_HO_SO: `${BaseGateway}/CMEAdmin/ApproveHoSo`,
    GET_CME_VAITRO: `${BaseGateway}/CMEAdmin/GetVaiTros`,
    GET_CME_DONVITINH: `${BaseGateway}/CMEAdmin/GetDonViTinhs`,
    UPSERT_CME_VAITRO: `${BaseGateway}/CMEAdmin/UpsertVaiTro`,
    UPSERT_CME_DONVITINH: `${BaseGateway}/CMEAdmin/UpsertDonViTinh`,
    DELETE_CME_VAITRO: `${BaseGateway}/CMEAdmin/DeleteVaiTro`, // sẽ + /{id}
    DELETE_CME_DONVITINH: `${BaseGateway}/CMEAdmin/DeleteDonViTinh`, // sẽ + /{id}
};

export const CME_KHOA_DAO_TAO_API = {
    GET_ALL: `${BaseGateway}/CMEKhoaDaoTao/GetAll`,
    GET_PAGING: `${BaseGateway}/CMEKhoaDaoTao/GetPaging`,
    GET_BY_ID: `${BaseGateway}/CMEKhoaDaoTao/GetById`, // + /{id}
    UPSERT: `${BaseGateway}/CMEKhoaDaoTao/Upsert`,
    DELETE: `${BaseGateway}/CMEKhoaDaoTao/Delete`, // + /{id}
    PREVIEW_IMPORT: `${BaseGateway}/CMEKhoaDaoTao/PreviewImport`, // + /{eventId}
    CONFIRM_IMPORT: `${BaseGateway}/CMEKhoaDaoTao/ConfirmImport`, // + /{eventId}
    LOCK_EVENT: `${BaseGateway}/CMEKhoaDaoTao/LockEvent`, // + /{id}
    GET_PARTICIPANTS: `${BaseGateway}/CMEKhoaDaoTao/GetParticipants`, // + /{eventId}
};

export const CME_DIEU_DUONG_API = {
    GET_ALL: `${BaseGateway}/CMEDieuDuongUser/GetAll`,
    GET_BY_ID: `${BaseGateway}/CMEDieuDuongAdmin/GetById`, // + /{id}
    UPSERT: `${BaseGateway}/CMEDieuDuongAdmin/Upsert`,
    DELETE: `${BaseGateway}/CMEDieuDuongAdmin/Delete`, // + /{id}
    TOGGLE_CHECKIN: `${BaseGateway}/CMEDieuDuongAdmin/ToggleDiemDanhBatDau`, // + /{id}
    TOGGLE_CHECKOUT: `${BaseGateway}/CMEDieuDuongAdmin/ToggleDiemDanhKetThuc`, // + /{id}
    CHECKIN: `${BaseGateway}/CMEDieuDuongUser/DiemDanhBatDau`, // + /{eventId}
    CHECKOUT: `${BaseGateway}/CMEDieuDuongUser/DiemDanhKetThuc`, // + /{eventId}
    GET_ATTENDANCE: `${BaseGateway}/CMEDieuDuongAdmin/GetDiemDanhList`, // + /{eventId}
    SAVE_LIST: `${BaseGateway}/CMEDieuDuongAdmin/LuuDanhSach`, // + /{eventId}
    SYNC_UNITS: `${BaseGateway}/CMEDieuDuongAdmin/SyncUnits`, // + /{eventId}
    APPROVE_STEP1: `${BaseGateway}/CMEDieuDuongAdmin/DuyetBuoc1`, // + /{eventId}
    SAVE_PHU_LUC_2_FILE_STATE: `${BaseGateway}/CMEDieuDuongAdmin/SavePhuLuc2FileState`, // + /{eventId}
    RESET_PHU_LUC_2_FILE_STATE: `${BaseGateway}/CMEDieuDuongAdmin/ResetPhuLuc2FileState`, // + /{eventId}
    APPROVE_STEP2: `${BaseGateway}/CMEDieuDuongDuyet/DuyetBuoc2`,
    GET_STEP2_PAGING: `${BaseGateway}/CMEDieuDuongDuyet/GetDuyetBuoc2Paging`,
    GET_PAGING: `${BaseGateway}/CMEDieuDuongAdmin/GetPaging`,
    GET_BIEN_BAN: `${BaseGateway}/CMEDieuDuongAdmin/GetBienBan`, // + /{khoaId}
    UPSERT_BIEN_BAN: `${BaseGateway}/CMEDieuDuongAdmin/UpsertBienBan`,
    SAVE_BIEN_BAN_FILE_STATE: `${BaseGateway}/CMEDieuDuongAdmin/SaveBienBanFileState`, // + /{bienBanId}
    RESET_BIEN_BAN_FILE_STATE: `${BaseGateway}/CMEDieuDuongAdmin/ResetBienBanFileState`, // + /{bienBanId}
};

export const CME_USER_API = {
    GET_CATEGORIES: `${BaseGateway}/CMEUser/UserCategories`,
    GET_RULES: `${BaseGateway}/CMEUser/UserRules`, // sẽ + /{categoryId}
    GET_MY_HO_SO: `${BaseGateway}/CMEUser/UserPaging`,
    POST_USER_PAGING: `${BaseGateway}/CMEUser/UserPaging`,
    GET_BY_ID: `${BaseGateway}/CMEUser/UserHoSoById`, // sẽ + /{id}
    SUBMIT_HO_SO: `${BaseGateway}/CMEUser/UserSubmit`,
    DELETE_HO_SO: `${BaseGateway}/CMEUser/UserDelete`, // sẽ + /{id}
    POST_USER_CLONE: `${BaseGateway}/CMEUser/UserClone`,
    GET_MY_SUMMARY: `${BaseGateway}/CMEUser/UserSummary`,
};

export const PHAMVIHANHNGHE_API = {
    GET_PAGING: `${BaseGateway}/PhamViHanhNghe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/PhamViHanhNghe/GetItem`,
    ADD_ITEM: `${BaseGateway}/PhamViHanhNghe/Create`,
    UPDATE_ITEM: `${BaseGateway}/PhamViHanhNghe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/PhamViHanhNghe/DeleteItem`,
};


export const ACCOUNTINFO_API = {
    GET_PAGING: `${BaseGateway}/AccountInfo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AccountInfo/GetItem`,
    ADD_ITEM: `${BaseGateway}/AccountInfo/Create`,
    UPDATE_ITEM: `${BaseGateway}/AccountInfo/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AccountInfo/DeleteItem`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/AccountInfo/GetByAccountId`,
    GET_BY_ID_ACCOUNT: `${BaseGateway}/AccountInfo/SelectAccountInfoByAccountId`,
};

export const GIAYPHEPHANHNGHE_API = {
    GET_PAGING: `${BaseGateway}/GiayPhepHanhNghe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/GiayPhepHanhNghe/GetItem`,
    ADD_ITEM: `${BaseGateway}/GiayPhepHanhNghe/Create`,
    UPDATE_ITEM: `${BaseGateway}/GiayPhepHanhNghe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/GiayPhepHanhNghe/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/GiayPhepHanhNghe/UpdateField`,
    GET_ACCOUNT_INFO_ID: `${BaseGateway}/GiayPhepHanhNghe/GetByAccountInfoId`,
    GET_ALL: `${BaseGateway}/GiayPhepHanhNghe/GetAll`,
    GET_BY_GIAYPHEP_ID: `${BaseGateway}/GiayPhepHanhNghe/GetByGiayPhepHanhNgheId`,
    UPDATE_FIELD_DSDHS: `${BaseGateway}/GiayPhepHanhNghe/UpdateFieldDSDHS`,
    GET_PAGING_PHAMVIHANHNGHE: `${BaseGateway}/GiayPhepHanhNghe/GetAllByPagingPhamViHanhNghe`,
    GET_ALL_BY_PAGING_DANHMUCVANBANGCHUNGCHI: `${BaseGateway}/GiayPhepHanhNghe/GetAllByPagingDanhMucVanBangChungChi`

};

export const CHUNGCHI_CHUYENMON_API = {
    GET_PAGING: `${BaseGateway}/ChungChiChuyenMon/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChungChiChuyenMon/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChungChiChuyenMon/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChungChiChuyenMon/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChungChiChuyenMon/DeleteItem`,
    GET_BY_ACCOUNT_INFO_ID: `${BaseGateway}/ChungChiChuyenMon/GetByAccountInfoId`,
    UPDATE_LIST: `${BaseGateway}/ChungChiChuyenMon/UpdateList`,
    UPDATE_FIELD: `${BaseGateway}/ChungChiChuyenMon/UpdateField`
};
export const DONGPHIPHUC_API = {
    ADD_ITEM: `${BaseGateway}/DongPhiPhucKhao/Create`,
    UPDATE_ITEM: `${BaseGateway}/DongPhiPhucKhao/UpdateItem`,
    GET_BY_HOSO: `${BaseGateway}/DongPhiPhucKhao/GetByHoSoId`,
    GET_ALL_PAGING: `${BaseGateway}/DongPhiPhucKhao/GetAllPaging`
};

export const TRINHDO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/TrinhDo/GetAllByPaging`
};

export const QUOCGIA_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/QuocGia/GetAllByPaging`
};

export const DONVIDAOTAO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/DonViDaoTao/GetAllByPaging`
};

export const HINHTHUCDAOTAO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/HinhThucDaoTao/GetAllByPaging`
};

export const XEPLOAIDAOTAO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/XepLoaiDaoTao/GetAllByPaging`
};

export const DANHSACH_DUYET_HOSO_API = {
    ADD_ITEM: `${BaseGateway}/DanhSachDuyetHoSo/Create`,
    UPDATE_FIELD: `${BaseGateway}/DanhSachDuyetHoSo/UpdateField`,
    GET_BY_GIAYPHEP_ID: `${BaseGateway}/DanhSachDuyetHoSo/GetByGiayPhepHanhNgheId`,
    GET_ALL_BY_PAGING_GIAYPHEPHANHNGHE: `${BaseGateway}/DanhSachDuyetHoSo/GetAllByPagingGiayPhepHanhNghe`,
    GET_ALL_BY_PAGING: `${BaseGateway}/DanhSachDuyetHoSo/GetAllPaging`,
    UPDATE_FIELD_GPHN: `${BaseGateway}/DanhSachDuyetHoSo/UpdateFieldGPHN`,
    UPDATE_FIELD_CCCM: `${BaseGateway}/DanhSachDuyetHoSo/UpdateFieldCCCM`,
    GET_THONGKE_GPHN: `${BaseGateway}/DanhSachDuyetHoSo/GetThongKeGPHN`
};

export const DONVI_API = {
    GET_PAGING: `${BaseGatewayCommon}/DonVi/GetAllByPaging`,
};

export const CHUCVU_API = {
    GET_PAGING: `${BaseGatewayCommon}/ChucVu/GetAllByPaging`,
};

export const DOITUONG_API = {
    GET_PAGING: `${BaseGatewayCommon}/DoiTuong/GetAllByPaging`,
};

export const CHUYENMON_API = {
    GET_PAGING: `${BaseGatewayCommon}/ChuyenMon/GetAllByPaging`,
};

export const ADDRESS_API = {
    GET_PROVINCES: `${BaseGateway}/AddressProxy/GetProvinces`,
    GET_WARDS: `${BaseGateway}/AddressProxy/GetWards`,
};

export const VANBANG_API = {
    GET_PAGING: `${BaseGateway}/VanBang/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/VanBang/GetItem`,
    ADD_ITEM: `${BaseGateway}/VanBang/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBang/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/VanBang/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/VanBang/UpdateField`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/VanBang/GetByAccountId`,
};

export const CHUNGCHINGOAINGU_API = {
    GET_PAGING: `${BaseGateway}/ChungChiNgoaiNgu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/ChungChiNgoaiNgu/UpdateField`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/ChungChiNgoaiNgu/GetByAccountId`,
};

export const DANHSACH_DUYET_NGOAINGU_API = {
    UPDATE_FIELD_VAN_BANG: `${BaseGateway}/DanhSachDuyetNgoaiNgu/UpdateFieldVanBang`,
    UPDATE_FIELD_CHUNG_CHI_NGOAI_NGU: `${BaseGateway}/DanhSachDuyetNgoaiNgu/UpdateFieldChungChiNgoaiNgu`,
    GET_ALL_VANBANG_BY_PAGING: `${BaseGateway}/DanhSachDuyetNgoaiNgu/GetAllVanBangByPaging`,
    GET_ALL_CHUNGCHINGOAINGU_BY_PAGING: `${BaseGateway}/DanhSachDuyetNgoaiNgu/GetAllChungChiNgoaiNguByPaging`,
    GET_THONGKE_NGOAINGU: `${BaseGateway}/DanhSachDuyetNgoaiNgu/GetThongKeNgoaiNgu`
};

export const HOPDONGCHITIET_API = {
    GET_PAGING: `${BaseGateway}/HopDongChiTiet/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HopDongChiTiet/GetItem`,
    CREATE_ITEM: `${BaseGateway}/HopDongChiTiet/Create`,
    UPDATE_ITEM: `${BaseGateway}/HopDongChiTiet/UpdateItem`,
    UPDATE_STATUS: `${BaseGateway}/HopDongChiTiet/UpdateStatus`,
    DELETE_ITEM: `${BaseGateway}/HopDongChiTiet/DeleteItem`,
    GET_HOCVIENS: `${BaseGateway}/HopDongChiTiet/GetHocViens`,
    GET_GIANGVIENS: `${BaseGateway}/HopDongChiTiet/GetGiangViens`,
    IMPORT_HOCVIEN: `${BaseGateway}/HopDongChiTiet/ImportHocVien`,
    IMPORT_GIANGVIEN: `${BaseGateway}/HopDongChiTiet/ImportGiangVien`,
    SYNC_IMPORTED_ACCOUNTS: `${BaseGateway}/HopDongChiTiet/SyncImportedAccounts`,
    GET_TAILIEUS: `${BaseGateway}/HopDongChiTiet/GetTaiLieus`,
    ADD_TAILIEU: `${BaseGateway}/HopDongChiTiet/AddTaiLieu`,
    UPDATE_TAILIEU: `${BaseGateway}/HopDongChiTiet/UpdateTaiLieu`,
    DELETE_TAILIEU: `${BaseGateway}/HopDongChiTiet/DeleteTaiLieu`,
    GET_CHUONGTRINHS: `${BaseGateway}/HopDongChiTiet/GetChuongTrinhs`,
    ADD_CHUONGTRINH: `${BaseGateway}/HopDongChiTiet/AddChuongTrinh`,
    UPDATE_CHUONGTRINH: `${BaseGateway}/HopDongChiTiet/UpdateChuongTrinh`,
    DELETE_CHUONGTRINH: `${BaseGateway}/HopDongChiTiet/DeleteChuongTrinh`,
    ADD_HOCVIEN_MANUALLY: `${BaseGateway}/HopDongChiTiet/AddHocVienManually`,
    ADD_GIANGVIEN_MANUALLY: `${BaseGateway}/HopDongChiTiet/AddGiangVienManually`,
    GET_TRANG_THAI_OPTIONS: `${BaseGateway}/HopDongChiTiet/GetTrangThaiOptions`,
    SAVE_AND_LINK_STUDENTS: `${BaseGateway}/HopDongChiTiet/SaveAndLinkStudents`,
    SAVE_AND_LINK_TUTORS: `${BaseGateway}/HopDongChiTiet/SaveAndLinkTutors`
};

export const LICHHOCTHUCHANH_API = {
    IMPORT: `${BaseGateway}/LichHocThucHanh/Import`,
    CONFIRM: `${BaseGateway}/LichHocThucHanh/Confirm`,
    GET_BY_COURSE: `${BaseGateway}/LichHocThucHanh/GetByCourse`,
    UPDATE_ITEM: `${BaseGateway}/LichHocThucHanh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/LichHocThucHanh/DeleteItem`,
    GET_EXCEL_KHOA_MAPPINGS: `${BaseGateway}/LichHocThucHanh/GetExcelKhoaMappings`,
    CREATE_EXCEL_KHOA_MAPPING: `${BaseGateway}/LichHocThucHanh/CreateExcelKhoaMapping`,
    DELETE_EXCEL_KHOA_MAPPING: `${BaseGateway}/LichHocThucHanh/DeleteExcelKhoaMapping`,
    GET_STUDENT_TIMELINE: `${BaseGateway}/LichHocThucHanh/StudentTimeline`,
    GET_INSTRUCTOR_AGENDA: `${BaseGateway}/LichHocThucHanh/InstructorAgenda`,
    GET_ADMIN_MATRIX: `${BaseGateway}/LichHocThucHanh/AdminMatrix`,
    GET_DIEM_DANH_SESSION: `${BaseGateway}/LichHocThucHanh/GetDiemDanhSession`,
    SAVE_DIEM_DANH: `${BaseGateway}/LichHocThucHanh/SaveDiemDanh`,
    KIEM_TRA_HOC_VIEN_NGOAI_LICH: `${BaseGateway}/LichHocThucHanh/KiemTraHocVienNgoaiLich`,
    BO_SUNG_HOC_VIEN_NGOAI_LICH: `${BaseGateway}/LichHocThucHanh/BoSungHocVienNgoaiLich`,
    HUY_BO_SUNG_HOC_VIEN: `${BaseGateway}/LichHocThucHanh/HuyBoSungHocVien`,
    BAO_CAO_DIEM_DANH: `${BaseGateway}/LichHocThucHanh/BaoCaoDiemDanh`
};

export const TRUONGTHUCTAP_API = {
    GET_PAGING: `${BaseGateway}/TruongThucTap/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/TruongThucTap/GetItem`,
    CREATE_ITEM: `${BaseGateway}/TruongThucTap/Create`,
    UPDATE_ITEM: `${BaseGateway}/TruongThucTap/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/TruongThucTap/DeleteItem`
};

export const HOPDONGNGUYENTAC_API = {
    GET_PAGING: `${BaseGateway}/HopDongNguyenTac/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HopDongNguyenTac/GetItem`,
    CREATE_ITEM: `${BaseGateway}/HopDongNguyenTac/Create`,
    UPDATE_ITEM: `${BaseGateway}/HopDongNguyenTac/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HopDongNguyenTac/DeleteItem`
};

export const NGANHDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/NganhDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/NganhDaoTao/GetItem`,
    CREATE_ITEM: `${BaseGateway}/NganhDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/NganhDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/NganhDaoTao/DeleteItem`
};

export const CHUONGTRINHDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/ChuongTrinhDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuongTrinhDaoTao/GetItem`,
    CREATE_ITEM: `${BaseGateway}/ChuongTrinhDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuongTrinhDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuongTrinhDaoTao/DeleteItem`
}
    export const KETQUATUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/KetQuaTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/KetQuaTuyenSinh/GetItem`,
    CREATE_ITEM: `${BaseGateway}/KetQuaTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/KetQuaTuyenSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/KetQuaTuyenSinh/DeleteItem`
};

export const DANHGIA_THISINH_API = {
    GET_PAGING: `${BaseGateway}/DanhGiaThiSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DanhGiaThiSinh/GetItem`,
    CREATE_ITEM: `${BaseGateway}/DanhGiaThiSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhGiaThiSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhGiaThiSinh/DeleteItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/DanhGiaThiSinh/GetByHoSoId`
};

export const DANHGIA_HOSO_TIENSI_API = {
    GET_PAGING: `${BaseGateway}/DanhGiaHoSoTuyenSinhTienSi/GetAllPaging`,
    GET_BY_HOSO_ID: `${BaseGateway}/DanhGiaHoSoTuyenSinhTienSi/GetByHoSoId`,
    CREATE_ITEM: `${BaseGateway}/DanhGiaHoSoTuyenSinhTienSi/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhGiaHoSoTuyenSinhTienSi/UpdateItem`
};

export const QRGENERATOR_API = {
    CREATE: `${BaseGateway}/QRGenerator/Create`,
};

export const HOSO_NGHIENCUUSINH_API = {
    GET_PAGING: `${BaseGateway}/HoSoNghienCuuSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HoSoNghienCuuSinh/GetItem`
};

export const QUANLY_HOSONGHIENCUUSINH_API = {
    GET_PAGING: `${BaseGateway}/QuanLyHoSoNghienCuuSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/QuanLyHoSoNghienCuuSinh/GetItem`
};

export const HOCPHANTIENSI_API = {
    GET_PAGING: `${BaseGateway}/HocPhanTienSi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HocPhanTienSi/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/HocPhanTienSi/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/HocPhanTienSi/Create`,
    UPDATE_ITEM: `${BaseGateway}/HocPhanTienSi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HocPhanTienSi/DeleteItem`
};

export const CHAMDECUONG_API = {
    GET_PAGING: `${BaseGateway}/ChamDeCuong/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChamDeCuong/GetItem`,
    GET_BY_HOCPHAN_ID: `${BaseGateway}/ChamDeCuong/GetByHocPhanTienSiId`,
    CREATE: `${BaseGateway}/ChamDeCuong/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChamDeCuong/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChamDeCuong/DeleteItem`
};

export const DUYET_HOCPHANTIENSI_API = {
    GET_PAGING: `${BaseGateway}/DuyetHocPhanTienSi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetHocPhanTienSi/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetHocPhanTienSi/DuyetHoSo`
};

export const CHUYENDETIENSI_API = {
    GET_PAGING: `${BaseGateway}/ChuyenDeTienSi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuyenDeTienSi/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/ChuyenDeTienSi/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/ChuyenDeTienSi/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuyenDeTienSi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuyenDeTienSi/DeleteItem`
};

export const CHAMCHUYENDE_API = {
    GET_PAGING: `${BaseGateway}/ChamChuyenDe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChamChuyenDe/GetItem`,
    GET_BY_CHUYENDE_ID: `${BaseGateway}/ChamChuyenDe/GetByChuyenDeTienSiId`,
    CREATE: `${BaseGateway}/ChamChuyenDe/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChamChuyenDe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChamChuyenDe/DeleteItem`
};

export const DUYET_CHUYENDETIENSI_API = {
    GET_PAGING: `${BaseGateway}/DuyetChuyenDeTienSi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetChuyenDeTienSi/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetChuyenDeTienSi/DuyetHoSo`
};

export const TIEULUANTONGQUAN_API = {
    GET_PAGING: `${BaseGateway}/TieuLuanTongQuan/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/TieuLuanTongQuan/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/TieuLuanTongQuan/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/TieuLuanTongQuan/Create`,
    UPDATE_ITEM: `${BaseGateway}/TieuLuanTongQuan/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/TieuLuanTongQuan/DeleteItem`
};

export const CHAMTIEULUAN_API = {
    GET_PAGING: `${BaseGateway}/ChamTieuLuan/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChamTieuLuan/GetItem`,
    GET_BY_TIEULUAN_ID: `${BaseGateway}/ChamTieuLuan/GetByTieuLuanTongQuanId`,
    CREATE: `${BaseGateway}/ChamTieuLuan/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChamTieuLuan/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChamTieuLuan/DeleteItem`
};

export const DUYET_TIEULUANTONGQUAN_API = {
    GET_PAGING: `${BaseGateway}/DuyetTieuLuanTongQuan/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetTieuLuanTongQuan/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetTieuLuanTongQuan/DuyetHoSo`
};

export const DECUONGDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/DeCuongDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DeCuongDaoTao/GetItem`,
    CREATE_ITEM: `${BaseGateway}/DeCuongDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/DeCuongDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DeCuongDaoTao/DeleteItem`
};

export const CANBODAOTAO_API = {
    GET_PAGING: `${BaseGateway}/CanBoDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/CanBoDaoTao/GetItem`,
    CREATE_ITEM: `${BaseGateway}/CanBoDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/CanBoDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/CanBoDaoTao/DeleteItem`
};

export const LICHSUTHANHTOAN_API = {
    GET_PAGING: `${BaseGateway}/LichSuThanhToan/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/LichSuThanhToan/GetItem`,
    GET_ITEM_BY_CUSTCODE: `${BaseGateway}/LichSuThanhToan/GetItemByCustCode`,
    ADD_ITEM: `${BaseGateway}/LichSuThanhToan/Create`,
    UPDATE_ITEM: `${BaseGateway}/LichSuThanhToan/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/LichSuThanhToan/DeleteItem`
};

export const YEUCAU_THAYDOI_API = {
    GET_PAGING: `${BaseGateway}/YeuCauThayDoi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/YeuCauThayDoi/GetItem`,
    CREATE: `${BaseGateway}/YeuCauThayDoi/Create`,
    UPDATE_ITEM: `${BaseGateway}/YeuCauThayDoi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/YeuCauThayDoi/DeleteItem`
};

export const THAYDOI_DETAI_API = {
    GET_PAGING: `${BaseGateway}/ThayDoiDeTai/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ThayDoiDeTai/GetItem`,
    GET_BY_YEUCAU_ID: `${BaseGateway}/ThayDoiDeTai/GetByYeuCauThayDoiId`,
    CREATE: `${BaseGateway}/ThayDoiDeTai/Create`,
    UPDATE_ITEM: `${BaseGateway}/ThayDoiDeTai/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ThayDoiDeTai/DeleteItem`
};

export const DUYET_THAYDOI_DETAI_API = {
    GET_PAGING: `${BaseGateway}/DuyetThayDoiDeTai/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetThayDoiDeTai/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetThayDoiDeTai/DuyetHoSo`,
};

export const DUYET_THAYDOI_CBHD_API = {
    GET_PAGING: `${BaseGateway}/DuyetThayDoiCBHD/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetThayDoiCBHD/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetThayDoiCBHD/DuyetHoSo`,
};

export const DUYET_GIAHAN_DAOTAO_API = {
    GET_PAGING: `${BaseGateway}/DuyetGiaHanDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetGiaHanDaoTao/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetGiaHanDaoTao/DuyetHoSo`,
};

export const DANHGIA_DETAI_API = {
    GET_PAGING: `${BaseGateway}/DanhGiaDeTai/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DanhGiaDeTai/GetItem`,
    GET_BY_THAYDOI_ID: `${BaseGateway}/DanhGiaDeTai/GetByThayDoiDeTaiId`,
    CREATE: `${BaseGateway}/DanhGiaDeTai/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhGiaDeTai/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhGiaDeTai/DeleteItem`,
};

export const DANHGIA_CBHD_API = {
    GET_PAGING: `${BaseGateway}/DanhGiaCBHD/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DanhGiaCBHD/GetItem`,
    GET_BY_THAYDOI_ID: `${BaseGateway}/DanhGiaCBHD/GetByThayDoiCBHDId`,
    CREATE: `${BaseGateway}/DanhGiaCBHD/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhGiaCBHD/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhGiaCBHD/DeleteItem`,
};

export const CHITIET_DANHGIA_CBHD_API = {
    GET_PAGING: `${BaseGateway}/ChiTietDanhGiaCBHD/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChiTietDanhGiaCBHD/GetItem`,
    GET_BY_DANHGIA_ID: `${BaseGateway}/ChiTietDanhGiaCBHD/GetByDanhGiaCBHDId`,
    CREATE: `${BaseGateway}/ChiTietDanhGiaCBHD/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChiTietDanhGiaCBHD/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChiTietDanhGiaCBHD/DeleteItem`,
};

export const DANHGIA_GIAHAN_API = {
    GET_PAGING: `${BaseGateway}/DanhGiaGiaHan/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DanhGiaGiaHan/GetItem`,
    GET_BY_THAYDOI_ID: `${BaseGateway}/DanhGiaGiaHan/GetByGiaHanDaoTaoId`,
    CREATE: `${BaseGateway}/DanhGiaGiaHan/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhGiaGiaHan/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhGiaGiaHan/DeleteItem`,
};

export const THAYDOI_CBHD_API = {
    GET_PAGING: `${BaseGateway}/ThayDoiCBHD/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ThayDoiCBHD/GetItem`,
    GET_BY_YEUCAU_ID: `${BaseGateway}/ThayDoiCBHD/GetByYeuCauThayDoiId`,
    CREATE: `${BaseGateway}/ThayDoiCBHD/Create`,
    UPDATE_ITEM: `${BaseGateway}/ThayDoiCBHD/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ThayDoiCBHD/DeleteItem`
};

export const GIAHAN_DAOTAO_API = {
    GET_PAGING: `${BaseGateway}/GiaHanDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/GiaHanDaoTao/GetItem`,
    GET_BY_YEUCAU_ID: `${BaseGateway}/GiaHanDaoTao/GetByYeuCauThayDoiId`,
    CREATE: `${BaseGateway}/GiaHanDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/GiaHanDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/GiaHanDaoTao/DeleteItem`
};

export const CHITIET_THAYDOI_CBHD_API = {
    GET_PAGING: `${BaseGateway}/ChiTietThayDoiCBHD/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChiTietThayDoiCBHD/GetItem`,
    GET_BY_THAYDOI_ID: `${BaseGateway}/ChiTietThayDoiCBHD/GetByThayDoiCBHDId`,
    CREATE: `${BaseGateway}/ChiTietThayDoiCBHD/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChiTietThayDoiCBHD/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChiTietThayDoiCBHD/DeleteItem`
};

export const HOIDONGDAODUC_API = {
    GET_PAGING: `${BaseGateway}/HoiDongDaoDuc/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HoiDongDaoDuc/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/HoiDongDaoDuc/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/HoiDongDaoDuc/Create`,
    UPDATE_ITEM: `${BaseGateway}/HoiDongDaoDuc/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HoiDongDaoDuc/DeleteItem`,
};

export const DUYET_HOIDONGDAODUC_API = {
    GET_PAGING: `${BaseGateway}/DuyetHoiDongDaoDuc/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetHoiDongDaoDuc/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetHoiDongDaoDuc/DuyetHoSo`,
};

export const HOCPHANBOSUNG_API = {
    GET_PAGING: `${BaseGateway}/HocPhanBoSung/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HocPhanBoSung/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/HocPhanBoSung/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/HocPhanBoSung/Create`,
    UPDATE_ITEM: `${BaseGateway}/HocPhanBoSung/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HocPhanBoSung/DeleteItem`,
};

export const DUYET_HOCPHANBOSUNG_API = {
    GET_PAGING: `${BaseGateway}/DuyetHocPhanBoSung/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetHocPhanBoSung/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetHocPhanBoSung/DuyetHoSo`,
};

export const KIEMTRASOLIEU_API = {
    GET_PAGING: `${BaseGateway}/KiemTraSoLieu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/KiemTraSoLieu/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/KiemTraSoLieu/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/KiemTraSoLieu/Create`,
    UPDATE_ITEM: `${BaseGateway}/KiemTraSoLieu/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/KiemTraSoLieu/DeleteItem`,
};

export const DUYET_KIEMTRASOLIEU_API = {
    GET_PAGING: `${BaseGateway}/DuyetKiemTraSoLieu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetKiemTraSoLieu/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetKiemTraSoLieu/DuyetHoSo`,
};

export const NOILAYSOLIEU_API = {
    GET_PAGING: `${BaseGateway}/NoiLaySoLieu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/NoiLaySoLieu/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/NoiLaySoLieu/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/NoiLaySoLieu/Create`,
    UPDATE_ITEM: `${BaseGateway}/NoiLaySoLieu/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/NoiLaySoLieu/DeleteItem`,
};

export const DUYET_NOILAYSOLIEU_API = {
    GET_PAGING: `${BaseGateway}/DuyetNoiLaySoLieu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetNoiLaySoLieu/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetNoiLaySoLieu/DuyetHoSo`,
};

export const QUATRINHLAYSOLIEU_API = {
    GET_PAGING: `${BaseGateway}/QuaTrinhLaySoLieu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/QuaTrinhLaySoLieu/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/QuaTrinhLaySoLieu/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/QuaTrinhLaySoLieu/Create`,
    UPDATE_ITEM: `${BaseGateway}/QuaTrinhLaySoLieu/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/QuaTrinhLaySoLieu/DeleteItem`,
};

export const CONGBOKHOAHOC_API = {
    GET_PAGING: `${BaseGateway}/CongBoKhoaHoc/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/CongBoKhoaHoc/GetItem`,
    GET_BY_QUATRINH_ID: `${BaseGateway}/CongBoKhoaHoc/GetByQuaTrinhLaySoLieuId`,
    CREATE: `${BaseGateway}/CongBoKhoaHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/CongBoKhoaHoc/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/CongBoKhoaHoc/DeleteItem`,
};

export const DIEUKIEN_QUYETDINH_API = {
    GET_PAGING: `${BaseGateway}/DieuKienQuyetDinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DieuKienQuyetDinh/GetItem`,
    GET_BY_KIEMTRA_ID: `${BaseGateway}/DieuKienQuyetDinh/GetByKiemTraSoLieuId`,
    CREATE: `${BaseGateway}/DieuKienQuyetDinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/DieuKienQuyetDinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DieuKienQuyetDinh/DeleteItem`
};

export const KEHOACHTIEPTHEO_API = {
    GET_PAGING: `${BaseGateway}/KeHoachTiepTheo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/KeHoachTiepTheo/GetItem`,
    GET_BY_QUATRINH_ID: `${BaseGateway}/KeHoachTiepTheo/GetByQuaTrinhLaySoLieuId`,
    CREATE: `${BaseGateway}/KeHoachTiepTheo/Create`,
    UPDATE_ITEM: `${BaseGateway}/KeHoachTiepTheo/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/KeHoachTiepTheo/DeleteItem`,
};

export const BAOVELUANANCOSO_API = {
    GET_PAGING: `${BaseGateway}/BaoVeLuanAnCoSo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/BaoVeLuanAnCoSo/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/BaoVeLuanAnCoSo/GetByHoSoNghienCuuSinhId`,
    ADD_ITEM: `${BaseGateway}/BaoVeLuanAnCoSo/Create`,
    UPDATE_ITEM: `${BaseGateway}/BaoVeLuanAnCoSo/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/BaoVeLuanAnCoSo/DeleteItem`
};

export const QUYETDINHBAOVE_API = {
    GET_PAGING: `${BaseGateway}/QuyetDinhBaoVe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/QuyetDinhBaoVe/GetItem`,
    GET_BY_BAOVE_ID: `${BaseGateway}/QuyetDinhBaoVe/GetByBaoVeLuanAnCoSoId`,
    CREATE: `${BaseGateway}/QuyetDinhBaoVe/Create`,
    UPDATE_ITEM: `${BaseGateway}/QuyetDinhBaoVe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/QuyetDinhBaoVe/DeleteItem`
};

export const QUYETDINHCAPVIEN_API = {
    GET_PAGING: `${BaseGateway}/QuyetDinhCapVien/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/QuyetDinhCapVien/GetItem`,
    GET_BY_BAOVE_ID: `${BaseGateway}/QuyetDinhCapVien/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/QuyetDinhCapVien/Create`,
    UPDATE_ITEM: `${BaseGateway}/QuyetDinhCapVien/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/QuyetDinhCapVien/DeleteItem`
};

export const DUYETBAOVELUANANCOSO_API = {
    GET_PAGING: `${BaseGateway}/DuyetBaoVeLuanAnCoSo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetBaoVeLuanAnCoSo/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetBaoVeLuanAnCoSo/DuyetBaoVeLuanAnCoSo`
};

export const PHANBIENDOCLAP_API = {
    GET_PAGING: `${BaseGateway}/PhanBienDocLap/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/PhanBienDocLap/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/PhanBienDocLap/GetByHoSoNghienCuuSinhId`,
    CREATE: `${BaseGateway}/PhanBienDocLap/Create`,
    UPDATE_ITEM: `${BaseGateway}/PhanBienDocLap/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/PhanBienDocLap/DeleteItem`
};

export const KETQUABAOVE_API = {
    GET_PAGING: `${BaseGateway}/KetQuaBaoVe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/KetQuaBaoVe/GetItem`,
    GET_BY_BAOVE_ID: `${BaseGateway}/KetQuaBaoVe/GetByBaoVeLuanAnCoSoId`,
    CREATE: `${BaseGateway}/KetQuaBaoVe/Create`,
    UPDATE_ITEM: `${BaseGateway}/KetQuaBaoVe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/KetQuaBaoVe/DeleteItem`
};

export const BAOVECAPVIEN_API = {
    GET_PAGING: `${BaseGateway}/BaoVeCapVien/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/BaoVeCapVien/GetItem`,
    GET_BY_HOSO_ID: `${BaseGateway}/BaoVeCapVien/GetByHoSoNghienCuuSinhId`,
    ADD_ITEM: `${BaseGateway}/BaoVeCapVien/Create`,
    UPDATE_ITEM: `${BaseGateway}/BaoVeCapVien/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/BaoVeCapVien/DeleteItem`
};

export const KETQUABAOVECAPVIEN_API = {
    GET_PAGING: `${BaseGateway}/KetQuaBaoVeCapVien/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/KetQuaBaoVeCapVien/GetItem`,
    GET_BY_BAOVECAPVIEN_ID: `${BaseGateway}/KetQuaBaoVeCapVien/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/KetQuaBaoVeCapVien/Create`,
    UPDATE_ITEM: `${BaseGateway}/KetQuaBaoVeCapVien/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/KetQuaBaoVeCapVien/DeleteItem`
};

export const TAILIEUKHAC_API = {
    GET_PAGING: `${BaseGateway}/TaiLieuKhac/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/TaiLieuKhac/GetItem`,
    GET_BY_BAOVECAPVIEN_ID: `${BaseGateway}/TaiLieuKhac/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/TaiLieuKhac/Create`,
    UPDATE_ITEM: `${BaseGateway}/TaiLieuKhac/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/TaiLieuKhac/DeleteItem`
};

export const DUYETBAOVECAPVIEN_API = {
    GET_PAGING: `${BaseGateway}/DuyetBaoVeCapVien/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetBaoVeCapVien/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetBaoVeCapVien/DuyetHoSo`
};

export const CONGBOTRENWEB_API = {
    GET_PAGING: `${BaseGateway}/CongBoTrenWeb/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/CongBoTrenWeb/GetItem`,
    GET_BY_BAOVECAPVIEN_ID: `${BaseGateway}/CongBoTrenWeb/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/CongBoTrenWeb/Create`,
    UPDATE_ITEM: `${BaseGateway}/CongBoTrenWeb/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/CongBoTrenWeb/DeleteItem`
};

export const CONGBOTHONGTIN_API = {
    GET_PAGING: `${BaseGateway}/CongBoThongTin/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/CongBoThongTin/GetItem`,
    GET_BY_BAOVECAPVIEN_ID: `${BaseGateway}/CongBoThongTin/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/CongBoThongTin/Create`,
    UPDATE_ITEM: `${BaseGateway}/CongBoThongTin/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/CongBoThongTin/DeleteItem`
};

export const NHANXETHOIDONG_API = {
    GET_PAGING: `${BaseGateway}/NhanXetHoiDong/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/NhanXetHoiDong/GetItem`,
    GET_BY_BAOVECAPVIEN_ID: `${BaseGateway}/NhanXetHoiDong/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/NhanXetHoiDong/Create`,
    UPDATE_ITEM: `${BaseGateway}/NhanXetHoiDong/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/NhanXetHoiDong/DeleteItem`
};

export const DIEUKIENTOCHUC_API = {
    GET_PAGING: `${BaseGateway}/DieuKienToChuc/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DieuKienToChuc/GetItem`,
    GET_BY_BAOVECAPVIEN_ID: `${BaseGateway}/DieuKienToChuc/GetByBaoVeCapVienId`,
    CREATE: `${BaseGateway}/DieuKienToChuc/Create`,
    UPDATE_ITEM: `${BaseGateway}/DieuKienToChuc/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DieuKienToChuc/DeleteItem`
};